import { cva } from 'class-variance-authority'

const headingVariants = cva('font-heading', {
  variants: {
    variant: {
      h1: 'text-100 leading-110 font-600 tracking-30',
      h2: 'text-90 leading-100 font-600 tracking-30',
      h3: 'text-80 leading-80 font-600 tracking-20',
      h4: 'text-70 leading-70 font-600 tracking-20',
      h5: 'text-60 leading-60 font-600 tracking-10',
      h6: 'text-50 leading-50 font-600 tracking-10',
    },
    // Override only. Omitted → the baseline weight from `variant.*` applies.
    // Concatenated after `variant`, so `cn()`/tailwind-merge keeps this weight.
    weight: {
      regular: 'font-400',
      medium: 'font-500',
      semibold: 'font-600',
    },
  },
  defaultVariants: {
    variant: 'h1',
  },
})

export { headingVariants }
